import React from 'react'
import { track } from 'analytics'
import { openModal, preloadModal } from 'modals'
import { formatPrice } from 'helpers'

import { Button, buttonMessages, type ButtonProps } from 'components/inputs'


type CandleClubSubscribeButtonProps = Partial<Pick<ButtonProps, 'className' | 'size' | 'style' | 'width' | 'fullWidth' | 'fullWidthOnMobile' | 'data-testid'>> & {
  placement: string
} & AtLeastOne<{
  title: Intl.Message | string
  price: number
}>


const CandleClubSubscribeButton: React.FC<CandleClubSubscribeButtonProps> = (props) => {
  const { className, title, price, placement, size = 56, style = 'primary',
    width, fullWidth, fullWidthOnMobile, 'data-testid': dataTestId = 'candleSubscriptionButton' } = props

  const handleSubscribeClick = () => {
    track('Banner click', {
      placement,
      content: 'Candle subscription',
      action: 'Subscribe',
    })

    openModal('candleSubscriptionConfirmationModal', { action: 'subscribe' })
  }

  const handleMouseOver = () => {
    void preloadModal('candleSubscriptionConfirmationModal')
  }

  return (
    <Button
      className={className}
      title={title || { ...buttonMessages.subscribeForPrice, values: { price: formatPrice(price || 2500) } }}
      size={size}
      style={style}
      width={width}
      fullWidth={fullWidth}
      fullWidthOnMobile={fullWidthOnMobile}
      onClick={handleSubscribeClick}
      onMouseOver={handleMouseOver}
      data-testid={dataTestId}
    />
  )
}


export default CandleClubSubscribeButton
